if (!customElements.get('gf-colour-preference')) {
  customElements.define('gf-colour-preference', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = this.closest('form');
      if (!this.form) return;
      this.excluded = new Set((this.dataset.excludedVariants || '').split(',').filter(Boolean));
      this.confirmation = this.querySelector('[data-colour-confirmation]');
      this.preference = this.querySelector('[data-colour-preference]');
      const options = { signal: this.controller.signal };
      this.form.addEventListener('change', () => this.sync(), options);
      this.form.addEventListener('submit', () => this.sync(), { ...options, capture: true });
      this.form.addEventListener('formdata', event => {
        const eligible = this.sync();
        if (!this.confirmation) return;
        if (eligible) event.formData.set(this.confirmation.name, this.confirmation.value);
        else event.formData.delete(this.confirmation.name);
        if (this.preference) {
          const value = this.preference.value.trim();
          if (eligible && value) event.formData.set(this.preference.name, value);
          else event.formData.delete(this.preference.name);
        }
      }, options);
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    sync() {
      const variant = this.form?.querySelector('[name="id"]');
      const eligible = !!variant?.value && !this.excluded.has(String(variant.value));
      this.hidden = this.hasAttribute('data-status-only') || !eligible;
      if (this.confirmation) this.confirmation.disabled = !eligible;
      if (this.preference) this.preference.disabled = !eligible;
      return eligible;
    }
  });
}
